(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["backinstock"] && !Shopify.designMode) return;
  try {
    'use strict';

  const SELECTORS = {
    BACK_IN_STOCK_BUTTON: '[data-back-in-stock-button]',
    DIALOG_NOTIFY_VARIANT_TITLE: '[data-dialog-notify-variant-title]',
    DIALOG_NOTIFY_BUTTON: '[data-dialog-notify-button]',
    DIALOG_NOTIFY_INPUT: '[data-dialog-notify-input]',
    DIALOG_NOTIFY_CONTAINER: '[data-dialog-notify-container]',
    DIALOG_NOTIFY_SUCCESS_MSG: '[data-dialog-notify-success-msg]',
    DIALOG_NOTIFY_ERROR_MSG: '[data-dialog-notify-error-msg]',
  };

  const { ThemeEvents, EventsConstructors } = window.POV;
  const { CartAddEvent } = EventsConstructors;

  const backInStockButton = document.querySelector(SELECTORS.BACK_IN_STOCK_BUTTON);
  // Klaviyo public API key is a block setting, rendered onto the button as a data attribute.
  const KLAVIYO_PUBLIC_API_KEY = backInStockButton.dataset.klaviyoCompanyId;
  const KLAVIYO_BACK_IN_STOCK_SUBSCRIPTIONS_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_PUBLIC_API_KEY;
  const dialogNotifyVariantTitleElement = document.querySelector(SELECTORS.DIALOG_NOTIFY_VARIANT_TITLE);
  const dialogNotifyButton = document.querySelector(SELECTORS.DIALOG_NOTIFY_BUTTON);
  const dialogNotifyInput = document.querySelector(SELECTORS.DIALOG_NOTIFY_INPUT);
  const dialogNotifyContainer = document.querySelector(SELECTORS.DIALOG_NOTIFY_CONTAINER);
  const dialogNotifySuccessMsg = document.querySelector(SELECTORS.DIALOG_NOTIFY_SUCCESS_MSG);
  const dialogNotifyErrorMsg = document.querySelector(SELECTORS.DIALOG_NOTIFY_ERROR_MSG);
  
  document.addEventListener(ThemeEvents.optionSelected, handleOptionSelected);
  dialogNotifyButton.addEventListener('click', handleNotifyWhenAvailable);

  function handleOptionSelected(event) {
    const { variant } = event.detail;
    window.POV.SelectedVariant = variant;

    if (!variant) {
      backInStockButton.classList.add('hidden');
      return;
    }

    if (variant.available) {
      backInStockButton.classList.add('hidden');
    } else {
      backInStockButton.classList.remove('hidden');
    }
  }
  
  async function handleNotifyWhenAvailable() {
    const isValid = dialogNotifyInput.validity.valid;

    dialogNotifyContainer.classList.remove('hidden');
    dialogNotifySuccessMsg.classList.add('hidden');
    dialogNotifyErrorMsg.classList.add('hidden');

    if (!isValid) {
      dialogNotifyInput.reportValidity();
      return;
    }

    const email = dialogNotifyInput.value;

    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": "$shopify:::$default:::" + window.POV.SelectedVariant.id
            }
          }
        }
      }
    }

    var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-06-15"
        },
        body: JSON.stringify(payload),
    };

    try {
      const response = await fetch(KLAVIYO_BACK_IN_STOCK_SUBSCRIPTIONS_URL, requestOptions);

      if (response.ok) {
        dialogNotifySuccessMsg.classList.remove('hidden');
        dialogNotifyContainer.classList.add('hidden');
      } else {
        dialogNotifyErrorMsg.classList.remove('hidden');
        dialogNotifySuccessMsg.classList.add('hidden');
      }
    } catch (error) {
      console.error('Error:', error);
      dialogNotifyErrorMsg.classList.remove('hidden');
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cartbutton"] && !Shopify.designMode) return;
  try {
    'use strict';

  const SELECTORS = {
    CART_BUTTON: '[data-cart]',
  };

  const { ThemeEvents } = window.POV;

  document.addEventListener(ThemeEvents.cartUpdated, handleCartUpdated);
  
  function handleCartUpdated(event) {
    const { itemCount } = event.detail;
    const cartDataNodes = Array.from(document.querySelectorAll(SELECTORS.CART_BUTTON) );
    cartDataNodes.forEach(cartDataNode => {
      cartDataNode.setAttribute('data-cart', itemCount || 0);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contactform"] && !Shopify.designMode) return;
  try {
    'use strict';

  const SELECTORS = {
    FORM: '[data-contact-form]',
    CATEGORY: '[data-contact-category]',
    SUBCATEGORY: '[data-contact-subcategory]',
    SUBCATEGORY_FIELD: '[data-contact-subcategory-field]',
  };

  function initContactForm(form) {
    if (form.dataset.contactFormReady) return;
    form.dataset.contactFormReady = 'true';

    const category = form.querySelector(SELECTORS.CATEGORY);
    const subcategory = form.querySelector(SELECTORS.SUBCATEGORY);
    const subcategoryField = form.querySelector(SELECTORS.SUBCATEGORY_FIELD);
    if (!category || !subcategory || !subcategoryField) return;

    category.addEventListener('change', handleCategoryChange);

    function handleCategoryChange() {
      const option = category.options[category.selectedIndex];
      // Sub-categories come from the contactcategory block's comma-separated setting.
      const items = ((option && option.dataset.subcategories) || '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);

      while (subcategory.options.length > 1) subcategory.remove(1);
      items.forEach((item) => {
        const element = document.createElement('option');
        element.value = `[${item}]`;
        element.textContent = item;
        subcategory.add(element);
      });

      subcategory.selectedIndex = 0;
      const hasItems = items.length > 0;
      subcategoryField.hidden = !hasItems;
      subcategory.disabled = !hasItems;
      subcategory.required = hasItems;
    }
  }

  document.querySelectorAll(SELECTORS.FORM).forEach(initContactForm);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(SELECTORS.FORM).forEach(initContactForm);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["details"] && !Shopify.designMode) return;
  try {
    'use strict';

    function handleDetailsState() {
      // Ignore viewport changes triggered by the on-screen keyboard (e.g. focusing
      // a number/text input on mobile), which would otherwise collapse the details.
      const activeElement = document.activeElement;
      if (activeElement && activeElement.matches('input, textarea, select')) return;

      const triggerElements = Array.from(document.querySelectorAll('details'));
      triggerElements.forEach(handleState);

      function handleState(detailsElement) {
        if (detailsElement.getAttribute('data-collapsible-expanded-mobile') === 'false') {
          if (matchMedia(`(max-width: ${window.POV.Breakpoints.L})`).matches) {
            detailsElement.removeAttribute('open');
          }
        }
        if (detailsElement.getAttribute('data-collapsible-expanded-desktop') === 'true') {
          if (matchMedia(`(min-width: ${window.POV.Breakpoints.L})`).matches) {
            detailsElement.setAttribute('open', true);
          }
        }
      }
    }

    document.addEventListener('DOMContentLoaded', handleDetailsState);
    // Only re-assert the open/closed state when the breakpoint actually changes,
    // not on every resize (mobile keyboards resize the viewport and would
    // otherwise close the details while typing in a filter input).
    matchMedia(`(max-width: ${window.POV.Breakpoints.L})`).addEventListener('change', handleDetailsState);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dialog"] && !Shopify.designMode) return;
  try {
    const dialogElements = Array.from(document.querySelectorAll('dialog'));
  dialogElements.forEach(setupDialog);

  function setupDialog(dialogElement) {
    const triggerElement = dialogElement.previousElementSibling;
    if (triggerElement && triggerElement.tagName === 'BUTTON') {
      triggerElement.setAttribute('aria-controls', dialogElement.id);
      triggerElement.addEventListener('click', () => dialogElement.showModal());
      dialogElement.addEventListener('close', ()=> triggerElement.focus());
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mobilesearch"] && !Shopify.designMode) return;
  try {
    const mobileSearchInput = document.querySelector('[data-search-input="mobile"]');
    const mobileSearchDetails = document.querySelector('[mobile-search-details]');

    if (mobileSearchInput && mobileSearchDetails) {

      mobileSearchInput.addEventListener('focus', handleVisibileState)
      mobileSearchInput.addEventListener('input', handleVisibileState);

      function handleVisibileState() {
        const value = mobileSearchInput.value.trim();
        if (value.length > 0) {
          mobileSearchDetails.setAttribute('open', true);
        } else {
          mobileSearchDetails.removeAttribute('open');
        }
      }
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["noticebanner"] && !Shopify.designMode) return;
  try {
    (function NoticeBanner() {
    'use strict';

    const SELECTORS = {
      BANNER: '[data-notice-banner]',
      DISMISS: '[data-notice-banner-dismiss]',
    };
    const COOKIE_PREFIX = 'POV_notice_banner_hide_';
    const DISMISS_DAYS = 30;

    if (!document.querySelector(SELECTORS.BANNER)) return;

    document.addEventListener('click', handleDismissClick);

    function handleDismissClick(event) {
      const trigger = event.target.closest(SELECTORS.DISMISS);
      if (!trigger) return;

      const banner = trigger.closest(SELECTORS.BANNER);
      if (!banner) return;

      window.POV.Cookie.write(COOKIE_PREFIX + banner.getAttribute('data-notice-banner'), 'true', DISMISS_DAYS);
      banner.setAttribute('hidden', '');
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["panelheader"] && !Shopify.designMode) return;
  try {
    (function handleCloseButton() {
    'use strict';

    document.addEventListener('click', function(event) {
      const trigger = event.target.closest('[data-toggle-panel]');
      if (!trigger) return;

      const parentElement = trigger.closest('details') || trigger.closest('dialog');
      if (parentElement) {
        if (parentElement.tagName === 'DIALOG') {
          parentElement.close();
        } else {
          parentElement.removeAttribute('open');
        }
      }
    });
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["productaddons"] && !Shopify.designMode) return;
  try {
    'use strict';

  const SELECTORS = {
    CONTAINER: '[data-product-addons]',
    CONFIG: '[data-product-addons-config]',
    ROW: '[data-product-addon]',
    TOGGLE: '[data-product-addon-toggle]',
    OPTION: '[data-product-addon-option]',
    IMAGE: '[data-product-addon-image]',
    LINE_INPUT: '[data-product-addon-line]',
    VARIANT_INPUT: '[data-product-addon-variant]',
    PRODUCT_CARD: '[data-product-item]',
    PRICE: ':is([data-main-product], [data-buy-bar]) [data-product-price]'
  };

  const ATTRIBUTES = {
    SHOW_FIRST: 'data-product-addons-show-first',
    ADDON_PRICE: 'data-product-addon-price',
    IMAGE_VARIANT: 'data-product-addon-image'
  };

  const container = document.querySelector(SELECTORS.CONTAINER);
  if (container) init(container);

  function init(container) {
    const config = JSON.parse(container.querySelector(SELECTORS.CONFIG).textContent);
    const formElement = document.getElementById(config.formId);
    const rows = Array.from(container.querySelectorAll(SELECTORS.ROW));
    const showFirst = container.hasAttribute(ATTRIBUTES.SHOW_FIRST);

    if (!formElement || rows.length === 0) return;

    renumberLines();
    container.addEventListener('change', handleChange);

    function handleChange(event) {
      if (event.target.matches(SELECTORS.TOGGLE)) {
        if (showFirst) syncShowFirst();
        rows.forEach(syncRow);
        updatePrices();
      } else if (event.target.matches(SELECTORS.OPTION)) {
        selectVariant(event.target);
      }
    }

    /**
     * The form already carries items[0] (the main variant) and, with productbonus,
     * items[1..n]; add-on lines continue the numbering so no line overwrites another.
     */
    function renumberLines() {
      const taken = Array.from(formElement.elements)
        .filter((element) => !element.matches(SELECTORS.LINE_INPUT))
        .map((element) => (element.name.match(/^items\[(\d+)\]/) || [])[1])
        .filter((index) => index !== undefined)
        .map(Number);
      let next = Math.max(0, ...taken) + 1;

      rows.forEach((row) => {
        row.querySelectorAll(SELECTORS.LINE_INPUT).forEach((input) => {
          input.name = input.name.replace(/^items\[\d+\]/, `items[${next}]`);
        });
        next += 1;
      });
    }

    // Line inputs only submit while the row is ticked (the ticked look is CSS, see the stylesheet)
    function syncRow(row) {
      const toggle = row.querySelector(SELECTORS.TOGGLE);

      row.querySelectorAll(SELECTORS.LINE_INPUT).forEach((input) => {
        input.disabled = !toggle.checked;
      });
    }

    // Show-first mode: the other add-ons only appear (and stay ticked) while the first one is ticked
    function syncShowFirst() {
      const first = rows[0].querySelector(SELECTORS.TOGGLE);

      rows.slice(1).forEach((row) => {
        row.hidden = !first.checked;
        if (!first.checked) row.querySelector(SELECTORS.TOGGLE).checked = false;
      });
    }

    // A colour swatch picks the add-on variant that goes in the cart and the thumbnail shown
    function selectVariant(option) {
      const row = option.closest(SELECTORS.ROW);

      row.querySelector(SELECTORS.VARIANT_INPUT).value = option.value;
      row.querySelectorAll(SELECTORS.IMAGE).forEach((image) => {
        image.hidden = image.getAttribute(ATTRIBUTES.IMAGE_VARIANT) !== option.value;
      });
    }

    // Re-render the main product's price (and compare-at price) with the ticked add-on prices included
    function updatePrices() {
      const extra = rows.reduce((sum, row) => {
        const toggle = row.querySelector(SELECTORS.TOGGLE);
        return toggle.checked ? sum + Number(toggle.getAttribute(ATTRIBUTES.ADDON_PRICE)) : sum;
      }, 0);

      document.querySelectorAll(SELECTORS.PRICE).forEach((element) => {
        if (element.closest(SELECTORS.PRODUCT_CARD)) return;
        element.dataset.priceAdjustment = extra;
        window.POV.ProductPrice.render(element);
      });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["productaddtocart"] && !Shopify.designMode) return;
  try {
    'use strict';

  const SELECTORS = {
    ADD_TO_CART_BUTTON: '[data-product-add-to-cart]',
    FORM_ELEMENT: 'form[action="/cart/add"]'
  };

  const { ThemeEvents, EventsConstructors } = window.POV;
  const { CartFormSubmittedEvent } = EventsConstructors;

  // Nodes — only this page's primary ATC form (not quick-buy [data-cart-form-add] forms)
  const addToCartButton = document.querySelector(SELECTORS.ADD_TO_CART_BUTTON);
  const formElement = addToCartButton ? addToCartButton.closest(SELECTORS.FORM_ELEMENT) : null;

  // Event listeners
  document.addEventListener(ThemeEvents.optionSelected, handleOptionSelected);
  document.addEventListener(ThemeEvents.cartUpdated, handleCartUpdated);
  document.addEventListener(ThemeEvents.cartErrored, handleCartErrored);

  function handleCartUpdated(event) {
    if (addToCartButton) {
      addToCartButton.removeAttribute('aria-busy');
    }
  }

  if (formElement) {
    formElement.addEventListener('submit', handleFormSubmit);
  }

  function handleFormSubmit(event) {
    event.preventDefault();
    addToCartButton.setAttribute('aria-busy', true);
    document.dispatchEvent(new CartFormSubmittedEvent({
      formElement: event.target,
    }));
  }
  
  function handleOptionSelected(event) {
    if (!addToCartButton) return;

    const { variant } = event.detail;
    window.POV.SelectedVariant = variant;

    if (variant) {
      if (variant.available) {
        addToCartButton.textContent = POV.Lang.ADD_TO_CART.toUpperCase();
        addToCartButton.removeAttribute('disabled');
      } else {
        addToCartButton.textContent = POV.Lang.OUT_OF_STOCK.toUpperCase();
        addToCartButton.setAttribute('disabled', true);
      }
    } else {
      addToCartButton.setAttribute('disabled', true);
      addToCartButton.textContent = POV.Lang.UNAVAILABLE.toUpperCase();
    }
  }

  function handleCartErrored(event) {
    if (addToCartButton) {
      addToCartButton.removeAttribute('aria-busy');
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["productbuybar"] && !Shopify.designMode) return;
  try {
    'use strict';

  const target = document.querySelector('[data-product-add-to-cart]'); // the target is the add to cart button
  const bar = document.querySelector('[data-buy-bar]');
  const buyBtn = document.querySelector('[data-buy-bar-target-trigger]');
  const atcBtn = document.querySelector('[data-product-add-to-cart]');

  if (!target || !bar || !buyBtn || !atcBtn) return;

  const { ThemeEvents } = window.POV;

  document.addEventListener(ThemeEvents.variantUpdated, e => {
    bar.setAttribute('data-buy-bar-available', Boolean(e.detail.variant?.available));
  });

  buyBtn.addEventListener('click', () => atcBtn.click());

  const observer = new IntersectionObserver(entries => {
    const isVisible = entries[0].boundingClientRect.y < entries[0].rootBounds.top;
    bar.toggleAttribute('data-buy-bar-hidden', !isVisible);
    document.body.classList.toggle('buy-bar-visible', isVisible);
  }, {
    rootMargin: '-25% 0px -25% 0px',
    threshold: 1
  });

  observer.observe(target);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["productgallery"] && !Shopify.designMode) return;
  try {
    'use strict';

  const { ThemeEvents } = window.POV;

  const SLIDERS = {
    PRODUCT_GALLERY: 'slider-product-gallery',
    THUMBS_GALLERY: 'slider-thumbs-gallery',
  };

  const SELECTORS = {
    THUMB_ELEMENTS: '[data-gallery-thumb]',
    THUMBS_TRACK: '#slider-thumbs-gallery [data-slider-track]',
    VIDEO_ELEMENTS: '[data-gallery-media-video] video',
  };

  // True while a pointer or finger is down on the thumb strip, so an automatic
  // reveal never fights a scroll the shopper is making themselves.
  let userIsScrollingThumbs = false;

  document.addEventListener(ThemeEvents.variantUpdated, handleVariantUpdate);
  document.addEventListener(ThemeEvents.sliderChanging, handleSliderChanging);
  document.addEventListener(ThemeEvents.sliderChanged, handleSliderChanged);

  const thumbs = Array.from(document.querySelectorAll(SELECTORS.THUMB_ELEMENTS));
  thumbs.forEach(thumb => thumb.addEventListener('click', () => handleThumbClick(thumb)));

  const thumbsTrack = document.querySelector(SELECTORS.THUMBS_TRACK);
  if (thumbsTrack) {
    ['pointerdown', 'touchstart'].forEach(type => {
      thumbsTrack.addEventListener(type, () => { userIsScrollingThumbs = true; }, { passive: true });
    });
    // Listen on window for the release: a mouse dragged off the strip is released
    // outside it, and a touch scroll cancels the pointer stream, so touchend is the
    // reliable end signal there.
    ['pointerup', 'touchend', 'touchcancel'].forEach(type => {
      window.addEventListener(type, () => { userIsScrollingThumbs = false; }, { passive: true });
    });
  }

  function handleVariantUpdate(event) {
    const {variant, productId} = event.detail;
    if (!variant || !productId) return;

    // Slides are keyed on product.media positions, which count video/3D entries; product.images does not.
    const position = variant.featured_media?.position;
    if (!position) return;

    const productGallery = POV.Slider.find(slider => slider.id === SLIDERS.PRODUCT_GALLERY);
    if (productGallery) productGallery.scrollToPosition(position);
  }

  // Fires as the gallery starts a programmatic scroll or a swipe passes a slide's
  // midpoint, so the thumb lights up as the move begins rather than once it settles.
  function handleSliderChanging(event) {
    if (event.detail.id !== SLIDERS.PRODUCT_GALLERY) return;
    syncThumbs(event.detail.position);
  }

  function handleSliderChanged(event) {
    if (event.detail.id !== SLIDERS.PRODUCT_GALLERY) return;

    pauseInactiveVideos(event.detail.position);
    // Safety net: the strip already synced on sliderChanging, so this is a no-op
    // unless a scroll was interrupted and settled somewhere else.
    syncThumbs(event.detail.position);
  }

  function syncThumbs(position) {
    const thumbsSlider = POV.Slider.find(slider => slider.id === SLIDERS.THUMBS_GALLERY);
    if (!thumbsSlider) return;

    // Already in sync (a thumb click marks its thumb active before the gallery
    // moves), so leave the strip exactly where it is.
    if (Number(activeThumbPosition(thumbsSlider)) === Number(position)) return;

    setActiveThumb(thumbsSlider, position);
    if (!userIsScrollingThumbs) thumbsSlider.revealPosition(position);
  }

  function handleThumbClick(thumbElement) {
    const position = thumbElement.getAttribute('data-position');
    const gallerySlider = POV.Slider.find(slider => slider.id === SLIDERS.PRODUCT_GALLERY);
    const thumbsSlider = POV.Slider.find(slider => slider.id === SLIDERS.THUMBS_GALLERY);

    // The clicked thumb is visible by definition, so only mark it active; the
    // strip must not move under the shopper's finger.
    setActiveThumb(thumbsSlider, position);
    gallerySlider.scrollToPosition(position);

    // The programmatic scroll above dispatches without a direction, so announce
    // the thumbnail navigation explicitly. The sliderChanging/sliderChanged runs
    // this triggers see the thumb already active and return early.
    const { SliderChangedEvent } = window.POV.EventsConstructors;
    document.dispatchEvent(new SliderChangedEvent({
      id: SLIDERS.PRODUCT_GALLERY,
      position: position,
      direction: 'thumbnail',
    }));
  }

  function activeThumbPosition(slider) {
    return slider.elements.track.querySelector('[data-active]')?.getAttribute('data-position');
  }

  function setActiveThumb(slider, position) {
    const item = slider.itemAtPosition(position);
    if (!item) return;

    slider.elements.items.forEach(item => item.removeAttribute('data-active'));
    item.setAttribute('data-active', true);
  }

  function pauseInactiveVideos(activePosition) {
    document.querySelectorAll(SELECTORS.VIDEO_ELEMENTS).forEach(video => {
      const slide = video.closest('[data-position]');
      const position = slide?.getAttribute('data-position');

      if (Number(position) !== Number(activePosition)) video.pause();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["productprice"] && !Shopify.designMode) return;
  try {
    'use strict';

  const { ThemeEvents } = window.POV;
  const { formatMoney } = window.POV.utils;

  window.POV.ProductPrice = { render: renderPrice };
  document.addEventListener(ThemeEvents.variantUpdated, handleVariantUpdate);

  function handleVariantUpdate(event) {
    const { productId, variant } = event.detail;
    if (!productId || !variant) return;

    document.querySelectorAll('[data-product-price]').forEach((element) => {
      if (element.dataset.productId !== String(productId)) return;
      if (element.closest('[data-product-item]')) return;

      element.dataset.basePrice = variant.price;
      element.dataset.baseCompareAtPrice = variant.compare_at_price ?? 0;
      renderPrice(element);
    });
  }

  // Always render from base values so repeated updates cannot compound an adjustment.
  function renderPrice(element) {
    const price = Number(element.dataset.basePrice);
    const compareAtPrice = Number(element.dataset.baseCompareAtPrice);
    const adjustment = Number(element.dataset.priceAdjustment);
    const format = element.dataset.moneyFormat;
    const onSale = compareAtPrice > price;

    element.querySelector('[data-price]').innerHTML = formatMoney(price + adjustment, format);
    element.querySelector('[data-compare-at-price]').innerHTML = formatMoney(compareAtPrice + adjustment, format);
    element.querySelectorAll('[data-price-sale]').forEach((sale) => { sale.hidden = !onSale; });

    const savings = element.querySelector('[data-price-savings]');
    if (savings) savings.innerHTML = formatMoney(compareAtPrice - price, format);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["productstockbadge"] && !Shopify.designMode) return;
  try {
    'use strict';

  const { ThemeEvents } = window.POV;

  const SELECTORS = {
    PRODUCT_STOCK_BADGE: '[data-product-stock-badge]',
    PRODUCT_STOCK_BADGE_TEXT: '[data-product-stock-badge-text]',
    PRODUCT_STOCK_BADGE_ICON: '[data-product-stock-badge] svg',
  };

  const productStockBadge = document.querySelector(SELECTORS.PRODUCT_STOCK_BADGE);
  const productStockBadgeText = document.querySelector(SELECTORS.PRODUCT_STOCK_BADGE_TEXT);
  const productStockBadgeIcon = document.querySelector(SELECTORS.PRODUCT_STOCK_BADGE_ICON);
  document.addEventListener(ThemeEvents.optionSelected, handleOptionSelected);

  function handleOptionSelected(event) {
    const { variant } = event.detail;

    if (!variant) {
      productStockBadge.classList.add('hidden');
      return;
    }

    productStockBadge.classList.remove('hidden');

    if (variant.available) {
      productStockBadgeText.textContent = POV.Lang.IN_STOCK;
      productStockBadgeIcon.setAttribute('fill', 'var(--p-color-base)');
    } else {
      productStockBadgeText.textContent = POV.Lang.OUT_OF_STOCK;
      productStockBadgeIcon.setAttribute('fill', 'var(--p-color-caution)');
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["productswatches"] && !Shopify.designMode) return;
  try {
    'use strict';
  
  const { ThemeEvents } = window.POV;

  const SELECTORS = {
    OPTION_NAME_LIST: '[data-option-position]',
  };

  document.addEventListener(ThemeEvents.variantUpdated, handleVariantUpdate);

  function handleVariantUpdate(event) {
    const {variant, productId, formElement} = event.detail;
    if (!variant || !productId || !formElement) return;

    const optionNameList = Array.from(document.querySelectorAll(
      `[data-option-form="${formElement.id}"]${SELECTORS.OPTION_NAME_LIST}`
    ));

    variant.options.forEach((optionName, index) => {
      optionNameList.forEach(optionNameElement => {
        if (Number(optionNameElement.getAttribute('data-option-position')) === index) {
          optionNameElement.textContent = optionName;
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
